
import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

const MarineTechnicalServices = () => {
  return (
    <div>
     

      {/* Cover Section */}
      <div className="service-cover">
        <img
          src="/images/marine.webp"
          alt="Marine Technical Services"
          className="service-cover-image"
        />
        <div className="service-cover-text">
          <h1>Marine Technical Services</h1>
          <p>Specialized Engineering | Vessel Maintenance | Performance Optimization</p>
        </div>
      </div>

      {/* Main Content */}
      <section className="service-section container">
        <div className="intro-text">
          <h2>Engineering Solutions That Keep You Sailing</h2>
          <p>
            Our Marine Technical Services ensure your vessel’s systems and infrastructure operate at peak efficiency.
            From onboard inspections to major retrofitting projects, we deliver reliable engineering expertise.
          </p>
          <p>
            With a team of certified marine engineers, technicians, and global partners, we offer tailored solutions
            that address every technical challenge—planned or emergency.
          </p>
        </div>

        {/* Services Grid */}
        <div className="service-grid">
          <div className="service-card">
            <img src="/images/inspection.webp" alt="Inspections" className="service-card-image" />
            <div className="service-card-content">
              <h3>Onboard Inspections & Diagnostics</h3>
              <ul>
                <li>Condition assessments & health checks</li>
                <li>Engine, electrical, HVAC & ballast system evaluation</li>
                <li>Survey reports for insurance or compliance</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/repairs.webp" alt="Repairs" className="service-card-image" />
            <div className="service-card-content">
              <h3>Emergency & Scheduled Repairs</h3>
              <ul>
                <li>Engine troubleshooting & overhauls</li>
                <li>Pump, piping & hydraulic system repairs</li>
                <li>Welding & fabrication support</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/proformance.webp" alt="Performance" className="service-card-image" />
            <div className="service-card-content">
              <h3>Performance Optimization</h3>
              <ul>
                <li>Fuel efficiency analysis & recommendations</li>
                <li>Propulsion system tuning</li>
                <li>Condition-based monitoring</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/retrofitting.webp" alt="Retrofit" className="service-card-image" />
            <div className="service-card-content">
              <h3>Retrofitting & Upgrades</h3>
              <ul>
                <li>Ballast Water Treatment Systems (BWTS)</li>
                <li>Emission control retrofits (scrubbers, etc.)</li>
                <li>Navigation & automation upgrades</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MarineTechnicalServices;
